import type { TimingConfig, AnimationConfig } from '../types';

export const TIMING: TimingConfig = {
  SHRINK_DURATION: 400,
  UNDO_DURATION: 500,
  TRAVEL_DURATION: 1000,
  PULSE_DURATION: 1000,
  PUBLISH_DURATION: 1000,
  IDEA_SPARK_DURATION: 1000,
  DELAY_BEFORE_MOVE: 0,
  RETURN_TO_CHAT_DELAY: 0,
  DEBOUNCE_DELAY: 100,
  ANIMATION_FRAME_DELAY: 16,
  BOREDOM_TIMEOUT: 7000,
  DOT_FADE_DURATION: 500,
  BLINK_INTERVAL: 3050,
  BLINK_VARIATION: 2950,
  BLINK_MIN_INTERVAL: 100,
};

export const ANIMATION_CONFIG: AnimationConfig = {
  TRAIL_COUNT: 21,
  TRAIL_STAGGER: 1.5,
  TRAIL_FADE: 0.25,
  TRAIL_MIN_SCALE: 0.9,
  TRAIL_BLUR: 0.6,
  DOT_SIZE: 12,
  DOT_COLOR: '#557DFF',
  SWAY_AMOUNT: 100,
  CONTROL_POINT_1: 0.33,
  CONTROL_POINT_2: 0.66,
  EASING: 'cubic-bezier(0.22,1,0.36,1)',
};
